var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C15.866 20 19 17.2322 19 13.8179C19 10.5446 17.3081 8.74985 14.7713 6.05895C13.9301 5.16669 12.9961 4.1759 12 3C11.0039 4.1759 10.0699 5.16669 9.22873 6.05895C6.69194 8.74985 5 10.5446 5 13.8179C5 17.2322 8.13401 20 12 20ZM11.5 16.1C10.612 16.1 9.77829 15.5605 9.35791 14.7664C8.958 14.011 8.93369 13.0236 9.70276 12.0622L8.29719 10.9378C7.0663 12.4764 7.04201 14.239 7.76709 15.6086C8.47171 16.9396 9.88801 17.9 11.5 17.9V16.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLiquidity);
export default __webpack_public_path__ + "static/media/hero-liquidity.29f52d74bb21355396f963f15d3d53c3.svg";
export { ForwardRef as ReactComponent };